import { useEffect } from 'react';
import { useTabContext } from './useTabContext';
import type { TabProps } from './Tabs.types';

export function Tab({
  id,
  label,
  content,
}: TabProps) {
  const {
    registerTab,
    unregisterTab,
  } = useTabContext();

  useEffect(() => {
    registerTab({
      id,
      label,
      content,
    });
    return () => unregisterTab(id);
  }, [
    id,
    label,
    content,
    registerTab,
    unregisterTab,
  ]);
  return null;
}
